import { render, staticRenderFns } from "./ScheduledLogisticCostsModal.vue?vue&type=template&id=b4d198ba&scoped=true"
import script from "./ScheduledLogisticCostsModal.vue?vue&type=script&lang=js"
export * from "./ScheduledLogisticCostsModal.vue?vue&type=script&lang=js"
import style0 from "./ScheduledLogisticCostsModal.vue?vue&type=style&index=0&id=b4d198ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d198ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4d198ba')) {
      api.createRecord('b4d198ba', component.options)
    } else {
      api.reload('b4d198ba', component.options)
    }
    module.hot.accept("./ScheduledLogisticCostsModal.vue?vue&type=template&id=b4d198ba&scoped=true", function () {
      api.rerender('b4d198ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shipping/ScheduledLogisticCostsModal.vue"
export default component.exports